import React, { useRef, useState } from 'react';
import { ConstructorEventUpdateSQLStatus } from "../../../Event/event";

const HalvingHoneyPots = () => {
  const [currentNumber, setCurrentNumber] = useState(12);
  const [questionMode, setQuestionMode] = useState(0);
  const [answer, setAnswer] = useState('');
  const [feedback, setFeedback] = useState('');
  const [score, setScore] = useState(0);
  const [showNext, setShowNext] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [feedbackColor, setFeedbackColor] = useState('black');

  const correctSound = useRef(new Audio('https://actions.google.com/sounds/v1/cartoon/clang_and_wobble.ogg'));
  const wrongSound = useRef(new Audio('https://actions.google.com/sounds/v1/cartoon/wood_plank_flicks.ogg'));

  const numbersToUse = [2, 4, 6, 8, 10, 12];

  const startNewQuestion = (num = currentNumber) => {
    const mode = Math.random() < 0.5 ? 0 : 1;
    setQuestionMode(mode);
    setCurrentNumber(num);
    setAnswer('');
    setFeedback('');
    setDisabled(false);
    setShowNext(false);
  };

  const handleCheck = () => {
    if (answer.trim() === '' || isNaN(answer)) {
      setFeedback('Please enter a number!');
      setFeedbackColor('red');
      return;
    }

    const correct = questionMode === 0 ? currentNumber / 2 : currentNumber;

    if (parseInt(answer) === correct) {
      setFeedback(`🎉 Correct! You had ${currentNumber} 🍯 and half is ${currentNumber / 2}!`);
       const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
      setFeedbackColor('green');
      setDisabled(true);
      setShowNext(true);
      correctSound.current.play();
      setScore(prev => prev + 1);
    } else {
      setFeedback('Try again! Think carefully about sharing equally or what number halves to this.');
      setFeedbackColor('red');
      wrongSound.current.play();
    }
  };

  return (
    <div style={{ fontFamily: 'Comic Sans MS, cursive', backgroundColor: '#fff6e5', color: '#5b3e1a', minHeight: '100vh', padding: '2rem' }}>
      <header style={{ background: '#f9a825', padding: '1.2rem', textAlign: 'center', fontSize: 'clamp(1.5rem, 4vw, 2.5rem)', color: '#fff', fontWeight: 'bold', boxShadow: '0 4px 10px #c17900' }}>
        Halving Honey Pots! 🍯🐻
      </header>

      <main style={{ textAlign: 'center', maxWidth: '600px', margin: '2rem auto' }}>
        <div style={{ fontSize: 'clamp(1rem, 3vw, 1.5rem)', marginBottom: '0.5rem' }}>Score: {score}</div>
        <div style={{ fontSize: 'clamp(1.1rem, 3.5vw, 1.7rem)', minHeight: '60px', marginBottom: '1rem' }}>
          {questionMode === 0
            ? `Bear wants to share ${currentNumber} honey pots equally with his friend. How many pots does each bear get?`
            : `Look! We have ${currentNumber / 2} honey pots. What number did we halve to get this?`}
        </div>

        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginBottom: '1.5rem', minHeight: '5rem' }}>
          {[...Array(currentNumber)].map((_, i) => (
            <span
              key={i}
              style={{
                fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
                margin: '0.25rem',
                transform: questionMode === 1 && i >= currentNumber / 2 ? 'scale(1.2)' : 'scale(1)',
                filter: questionMode === 1 && i >= currentNumber / 2 ? 'drop-shadow(0 0 5px #f9a825)' : 'none',
                transition: 'transform 0.3s ease'
              }}
            >
              🍯
            </span>
          ))}
        </div>

        <div>
          <input
            type="number"
            placeholder="Your answer"
            value={answer}
            onChange={e => setAnswer(e.target.value)}
            disabled={disabled}
            onKeyDown={e => {
              if (e.key === 'Enter') handleCheck();
            }}
            style={{
              fontSize: '1.3rem',
              padding: '0.5rem',
              width: 'min(80%, 250px)',
              margin: '0 auto 1.5rem',
              borderRadius: '6px',
              border: '2px solid #f9a825',
              textAlign: 'center',
              outline: 'none',
              display: 'block'
            }}
          />
          <button
            onClick={handleCheck}
            disabled={disabled}
            style={{
              fontSize: '1.3rem',
              marginLeft: '0.5rem',
              padding: '0.6rem 1.4rem',
              background: disabled ? '#fce588' : '#f9a825',
              border: 'none',
              borderRadius: '8px',
              color: disabled ? '#5b3e1a' : '#fff',
              cursor: disabled ? 'default' : 'pointer',
              boxShadow: '0 3px 8px #c17900'
            }}
          >
            Check
          </button>
        </div>

        <div style={{ marginTop: '1rem', fontWeight: 'bold', fontSize: 'clamp(1.2rem, 3vw, 1.4rem)', color: feedbackColor, minHeight: '30px' }}>{feedback}</div>

        {showNext && (
          <button
            onClick={() => {
              const nextNum = numbersToUse[Math.floor(Math.random() * numbersToUse.length)];
              startNewQuestion(nextNum);
            }}
            style={{
              marginTop: '1.5rem',
              fontSize: '1.3rem',
              padding: '0.6rem 1.4rem',
              background: '#f9a825',
              border: 'none',
              borderRadius: '8px',
              color: '#fff',
              cursor: 'pointer',
              boxShadow: '0 3px 8px #c17900'
            }}
          >
            Next 🍯
          </button>
        )}
      </main>
    </div>
  );
};

export default HalvingHoneyPots;
